import React, { Component } from "react";
import "../../css/utils/LoadingBar.css";

export default class FooterLoadingBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLoadingBar: props.showLoadingBar
        }
    }

    componentWillReceiveProps (props) {
        this.setState({
            showLoadingBar: props.showLoadingBar
        })
    }

    closeLoadingBar = () => {
        this.setState({
            showLoadingBar: "none"
        })
    }

    render() {

        return (
            <div className="loadingBarContainer" style={{display: this.state.showLoadingBar}}>
                <span className="loadingBarMessage">
                    <span className="glyphicon glyphicon-bullhorn"></span>
                    &nbsp; {this.props.text} &nbsp;

                    <span className="pullRight"
                          onClick={() => this.closeLoadingBar()}
                          style={{position:"relative", float:"left", cursor:"pointer", color:"#999"}}>
                        &nbsp; &nbsp; <span className="glyphicon glyphicon-remove-circle"></span>
                        &nbsp;Cancel
                    </span>
                </span>
                <span className="loadingBarFooter"></span>
                <span className="loadingBarBackground"></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/FooterLoadingBar.js